import React, { useState } from "react";
import { withStyles } from "@mui/styles";

import Button from "@mui/material/Button";
import ButtonGroup from "@mui/material/ButtonGroup";
import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";
import Dialog from "@mui/material/Dialog";
import MuiDialogTitle from "@mui/material/DialogTitle";
import MuiDialogContent from "@mui/material/DialogContent";
import MuiDialogActions from "@mui/material/DialogActions";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import Typography from "@mui/material/Typography";
import { IoMdCheckmark } from "react-icons/io";
import { useLanguageContext } from "../../../Context/LanguageContext";
import { toast } from "react-toastify";

const styles = (theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(2),
  },
  closeButton: {
    position: "absolute",
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
});

const DialogTitle = withStyles(styles)((props) => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle className={classes.root} {...other}>
      <Typography variant="h6">{children}</Typography>
      {onClose ? (
        <IconButton
          aria-label="close"
          className={classes.closeButton}
          onClick={onClose}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

const DialogContent = withStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
  },
}))(MuiDialogContent);

const DialogActions = withStyles((theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(1),
  },
}))(MuiDialogActions);

export default function AddBlockQuestions(props) {
  const { open, handleClose, addTemplate } = props;
  const { localization } = useLanguageContext();
  const initialTemplateState = [
    {
      title: localization.textInput,
      description: localization.textInputDesc,
      type: "text",
      count: 0,
    },

    {
      title: localization.booleanInput,
      description: localization.booleanInputDesc,
      type: "Yes/No",
      count: 0,
    },
    {
      title: localization.numericInput,
      description: localization.numericInputDesc,
      type: "Number",
      count: 0,
    },
    // {
    //   title: localization.selectionInput,
    //   description: localization.selectionInputDesc,
    //   type: "DropdownOption",
    //   count: 0,
    // },
    {
      title: localization.selectionInput,
      description:
        "Incorporate radio button for predefined responses, perfect for standardizing answers across inspections.",
      type: "RadioOption",
      count: 0,
    },
    {
      title: localization.rangeInput,
      description: localization.rangeInputDesc,
      type: "RangeValue",
      count: 0,
    },
  ];
  const [templateObj, setTemplateObj] = useState(initialTemplateState);

  const selectTemplate = (index, action) => {
    var tempObj = templateObj.map((object) => ({ ...object }));
    if (action == "Plus") {
      tempObj[index].count = tempObj[index].count + 1;
    } else {
      tempObj[index].count = Math.max(tempObj[index].count - 1, 0);
    }

    setTemplateObj(tempObj);
  };

  const handleAdd = () => {
    var selectedTemplates = templateObj.filter((template, index) => {
      return template.count > 0;
    });
    addTemplate(selectedTemplates);
    setTemplateObj(initialTemplateState);
  };

  return (
    <div>
      <Dialog
        fullWidth={true}
        onClose={handleClose}
        aria-labelledby="customized-dialog-title"
        open={open}
        className="questionDialog"
      >
        <DialogTitle id="customized-dialog-title" onClose={handleClose}>
          {localization.selectQuestionTemplate}
        </DialogTitle>
        <DialogContent dividers className="">
          {templateObj?.map((template, index) => {
            return (
              <div
                key={"template" + index}
                className="questionTemplateCard card"
              >
                <h2>{template.title}</h2>
                <p>{template.description}</p>
                {/* {template.isSelected && (
                  <div className="selectOverlay">
                    <IoMdCheckmark className="checkmarkIcon"></IoMdCheckmark>
                  </div>
                )} */}
                <ButtonGroup className="PlusMinusBtnGroupCls">
                  <Button
                    className="minusBtn"
                    aria-label="reduce"
                    onClick={() => {
                      selectTemplate(index, "Minus");
                    }}
                  >
                    <RemoveIcon fontSize="small" />
                  </Button>
                  <Button aria-label="count">{template.count}</Button>
                  <Button
                    className="plusBtn"
                    aria-label="increase"
                    onClick={() => {
                      selectTemplate(index, "Plus");
                    }}
                  >
                    <AddIcon fontSize="small" />
                  </Button>
                </ButtonGroup>
              </div>
            );
          })}
        </DialogContent>
        <DialogActions>
          <Button autoFocus onClick={handleAdd} color="primary">
            {localization.add}
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
